import Vue from 'vue';
import { isDevelopment } from 'Models/utils/Environment';

/**
 * @param {Element} element
 */
function checkForSubcomponents (element) {
    const subcomponents = element.querySelectorAll('[data-component]');

    if (!subcomponents.length) {
        return;
    }

    let hasVueSubcomponents = false;

    subcomponents.forEach(subcomponent => {
        const componentData = subcomponent.getAttribute('data-component');
        let config = false;
        if (componentData) {
            config = JSON.parse(componentData);
        }

        if (!config || config.factory === 'vue') {
            hasVueSubcomponents = true;
        }
    });

    if (hasVueSubcomponents) {
        throw new Error('Component has subcomponents: ' + element.tagName);
    }
}

export function create (element, config) {
    const isDev = isDevelopment();

    if (isDev) {
        try {
            checkForSubcomponents(element);
        } catch (e) {
            console.error(e);
        }
    }

    const elObject = { el: element };
    const optionsObject = config.options || {};
    const options = { ...elObject, ...optionsObject };
    // eslint-disable-next-line no-new
    new Vue(options);
}
